import * as Sentry from '@sentry/browser';
import React from 'react';
import ReactGA4 from 'react-ga4';
import { Navigate, Route, Routes } from 'react-router-dom';

import MainHeader from '../../components/Headers/MainHeader';
import SelfPromotionModal from '../../components/SelfPromotion/SelfPromotionModal';
import Sidebar from '../../components/Sidebar/Sidebar';
import ChangeRatingExamContainer from '../../containers/AccountSettingsContainer/changeRatingExamContainer.js';
import PdfViewerContainer from '../../containers/PdfViewerContainer';
import ROUTES from '../../routes/routes';
import history from '../../utils/history';
import {
  getLocalStorageItem,
  setLocalStorageItem,
} from '../../utils/localStorage';

class MainLayout extends React.Component {
  constructor(props) {
    super(props);

    // Check if we're in preview mode - same logic as QuestionContainer
    const hash = window.location.hash;
    const pathname = window.location.pathname;
    const isPreviewMode =
      hash.includes('questionPreview') || pathname.includes('questionPreview');

    this.state = {
      layoutPath: window.location.hash,
      practiceExamStatusChecked: false,
      showChangeRatingExamPopup: false,
      completeUserInfoStep: 0,
      warfarePlan: false,
      isPreviewMode,
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.user && this.props.user.id) {
      Sentry.setUser({
        email: this.props.user.email,
        id: this.props.user.id,
      });
    } else {
      Sentry.setUser({});
    }
    if (
      prevState.layoutPath != this.state.layoutPath &&
      this.state.layoutPath !== '#/login'
    ) {
      if (this.state.layoutPath.includes('/question/')) {
        ReactGA4.send({ hitType: 'pageview', page: '/#/app/question' });
      } else {
        ReactGA4.send({ hitType: 'pageview', page: this.state.layoutPath });
      }
    }
    if (
      !this.state.isPreviewMode &&
      prevProps.showPdfViewer !== this.props.showPdfViewer
    ) {
      window.Intercom?.('update', {
        hide_default_launcher: !!this.props.showPdfViewer,
      });
    }
  }

  UNSAFE_componentWillReceiveProps(prop) {
    if (window.location.hash !== this.state.layoutPath) {
      this.props.verifyLoggedUser();
      this.setState({ layoutPath: window.location.hash });
    }
    if (
      Object.keys(prop.user).length !== 0 &&
      !prop.loadingUser &&
      !this.state.showChangeRatingExamPopup
    ) {
      const showChangeRatingExamPopup =
        !prop.user.rate || !prop.user.rank || !prop.user.dutyState;
      if (showChangeRatingExamPopup) {
        let completeUserInfoStep = 1;
        if (showChangeRatingExamPopup) {
          this.props.getAllRates();
          this.props.loadPossibleCyclesForUser(prop.user);
          completeUserInfoStep = 0;
        }

        this.setState({
          showChangeRatingExamPopup: true,
          completeUserInfoStep,
        });
      }
    }
    if (
      prop.updateRatingExamMessage &&
      prop.updateRatingExamMessage === 'success'
    ) {
      this.props.getLoggedStudent();
      this.props.loadPossibleCyclesForUser(this.props.user);
    }
    if (prop.userSubscription) {
      if (
        prop.userSubscription.warfarePlan &&
        !prop.userSubscription.isCancelled
      ) {
        this.setState({
          warfarePlan: true,
        });
      }
    }
  }

  componentDidMount() {
    if (this.state.isPreviewMode) {
      return;
    }

    this.props.verifyLoggedUser();
    this.props.loadUserSubscription();
    this.props.setDailyQuiz(null);
    if (this.props.user?.id) {
      Sentry.setUser({
        email: this.props.user.email,
        id: this.props.user.id,
      });
    } else {
      Sentry.setUser({});
    }
  }

  UNSAFE_componentWillMount() {
    this.props.openPdfViewer(false);
  }

  getRoutes = (routes) => {
    const res = routes.map((route) => {
      if (route.path === '/*') {
        return (
          <Route
            path={route.path}
            element={<Navigate to="/app/dashboard" />}
            key={route.name}
          />
        );
      }
      return (
        <Route
          path={route.path}
          element={
            <route.component
              location={this.props.location}
              history={this.props.history}
            />
          }
          key={route.name}
        />
      );
    });
    return res;
  };

  nextEmptyUsernameAlert = (now) => {
    const alertTimePeriod = 259200000;
    const usernameAlert = Number(getLocalStorageItem('usernameAlert')) || 0;
    let nextAlert = usernameAlert - now;
    if (nextAlert <= 0) {
      nextAlert = alertTimePeriod;
    } else {
      nextAlert = 0;
    }
    return nextAlert;
  };

  SubmitRatingExamChange = (id, rate, rank, dutyState, cycleSelected) => {
    const newCycle = cycleSelected?.id || cycleSelected || null;
    const now = new Date().getTime();
    if (this.state.completeUserInfoStep === 0) {
      this.props.updateRatingExam(id, rate, rank, dutyState, newCycle);
      if (
        this.props.updateRatingExamMessage &&
        this.props.updateRatingExamMessage.type !== 'error'
      ) {
        if (
          this.props.user.username === '' &&
          this.nextEmptyUsernameAlert(now)
        ) {
          this.setState({ completeUserInfoStep: 1 });
        } else {
          this.setState({ showChangeRatingExamPopup: false });
        }
      }
    } else if (this.state.completeUserInfoStep === 1) {
      setLocalStorageItem(
        'usernameAlert',
        now + this.nextEmptyUsernameAlert(now),
        3 * 24 * 60 * 60 * 1000,
      );
      this.setState({ showChangeRatingExamPopup: false });
      history.push('/app/account-settings');
    }
  };

  onClosePopup = () => {
    if (this.state.completeUserInfoStep === 1) {
      const now = new Date().getTime();
      setLocalStorageItem(
        'usernameAlert',
        now + this.nextEmptyUsernameAlert(now),
        3 * 24 * 60 * 60 * 1000,
      );
      this.setState({
        showChangeRatingExamPopup: false,
      });
    }
  };

  render() {
    let collapsed = false;
    const pathname = this.props.location.pathname;
    let showMenu = true;
    if (
      pathname.indexOf('app/question') !== -1 ||
      pathname.indexOf('app/daily20quiz') !== -1 ||
      pathname.indexOf('app/practice-exam') !== -1
    ) {
      collapsed = true;
    } else {
      collapsed = false;
    }
    // show menu?
    if (pathname.indexOf('app/practice-exam') !== -1) {
      showMenu = false;
    }

    return (
      <>
        {/* Preview Mode Banner */}
        {this.state.isPreviewMode && (
          <div
            style={{
              backgroundColor: '#fff3cd',
              color: '#856404',
              padding: '15px',
              textAlign: 'center',
              borderBottom: '1px solid #ffeaa7',
              position: 'sticky',
              top: 0,
              zIndex: 1000,
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            }}
          >
            <strong>🔍 QUESTION PREVIEW MODE</strong> - This is a read-only
            preview. All interactions are disabled.
          </div>
        )}
        <ChangeRatingExamContainer
          isOpen={this.state.showChangeRatingExamPopup}
          onClose={this.onClosePopup}
          onSave={(id, rate, rank, dutyState, cycleSelected) =>
            this.SubmitRatingExamChange(
              id,
              rate,
              rank,
              dutyState,
              cycleSelected,
            )
          }
          completeUserInfoStep={this.state.completeUserInfoStep}
          message={this.props.updateRatingExamMessage}
          waiting={this.props.updateRatingExamWaiting}
          setUploadImageMessage={this.props.setUpdateRatingExamMessage}
          rates={this.props.rates}
          user={this.props.user}
          possibleCyclesForUser={this.props.possibleCyclesForUser}
        />

        {/* Only show Sidebar in non-preview mode */}
        {!this.state.isPreviewMode && (
          <Sidebar
            pfeSktId={this.props.pfeSktId}
            userSubscription={this.props.userSubscription}
            practiceExamAvailable={this.props.practiceExamAvailable}
            collapsed={collapsed}
            progress={this.props.progress ? this.props.progress : 0}
            pathName={pathname}
            quizAvailable={this.props.quizAvailable}
            startTimer={this.props.startTimer}
            timer={this.props.timer}
            user={this.props.user}
            checkDailyQuizStatus={this.props.checkDailyQuizStatus}
            checkDailyQuizStatusWaiting={this.props.checkDailyQuizStatusWaiting}
            nextQuizIn={this.props.nextQuizIn}
            dailyQuizRunning={this.props.dailyQuizRunning}
            setDailyTimeOut={this.props.setDailyTimeOut}
            dailyTimeOut={this.props.dailyTimeOut}
            quiz={this.props.quiz}
            activateSubscription={this.props.activateSubscription}
            subscriptionActivationSucces={
              this.props.subscriptionActivationSucces
            }
            subscriptionActivationWaiting={
              this.props.subscriptionActivationWaiting
            }
            subscriptionActivationMessage={
              this.props.subscriptionActivationMessage
            }
            history={this.props.history}
            setFlashSectionChoose={this.props.setFlashSectionChoose}
            checkQualDailyQuizStatus={this.props.checkQualDailyQuizStatus}
            isQualDailyQuizLoading={this.props.isQualDailyQuizLoading}
            isQualDailyQuizRunning={this.props.isQualDailyQuizRunning}
            nextQualDailyQuizIn={this.props.nextQualDailyQuizIn}
            qualDailyQuizProgress={this.props.qualDailyQuizProgress}
            qualDailyQuizTimeout={this.props.qualDailyQuizTimeout}
            setQualDailyQuiz={this.props.setQualDailyQuiz}
            setOneQualDailyQuizHistory={this.props.setOneQualDailyQuizHistory}
          />
        )}

        <div className="main-content">
          {/* Only show Sidebar in non-preview mode */}
          {!this.state.isPreviewMode && (
            <MainHeader
              questionNotificationState={this.props.questionNotification}
              receiveQuestionsNotification={
                this.props.activateReceiveQuestionsNotification
              }
              userSubscription={this.props.userSubscription}
              setBackTo={this.props.setBackTo}
              history={this.props.history}
              location={this.props.location}
              user={this.props.user}
              showMenu={showMenu}
              setShowMobileMenu={this.props.setShowMobileMenu}
              quizAvailable={this.props.quizAvailable}
              nextQuizIn={this.props.nextQuizIn}
              dailyQuizRunning={this.props.dailyQuizRunning}
              checkDailyQuizStatusWaiting={
                this.props.checkDailyQuizStatusWaiting
              }
              checkDailyQuizStatus={this.props.checkDailyQuizStatus}
              activateSubscription={this.props.activateSubscription}
              subscriptionActivationSucces={
                this.props.subscriptionActivationSucces
              }
              subscriptionActivationWaiting={
                this.props.subscriptionActivationWaiting
              }
              subscriptionActivationMessage={
                this.props.subscriptionActivationMessage
              }
              getPdfByReference={this.props.getPdfByReference}
              setFlashSectionChoose={this.props.setFlashSectionChoose}
            />
          )}

          {!this.props.showMobileMenu && (
            <div>
              <Routes>{this.getRoutes(ROUTES.APP)}</Routes>
            </div>
          )}

          {/* Only show Sidebar in non-preview mode */}
          {!this.state.isPreviewMode && (
            <>
              <PdfViewerContainer />
              <SelfPromotionModal />
            </>
          )}
        </div>
      </>
    );
  }
}
export default MainLayout;
